import React from 'react'
import { withRouter } from "react-router-dom";
import { FormComponent } from '../../../../components/form/DynamicForm';
import { Form, Validators } from '../../../../components/form/DynamicFormTs';
// import Http from '../../../../Http';

class repLegal extends FormComponent {
  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'cliente/one', saveUrl: 'cliente/save', backUrl: '/Catalogo/Cliente/' + this.props.match.params.id + '/repLegals' },
      new Form([
        Form.Field('text', 'cliente_rl_paterno', 'Apellido Paterno', '', [Validators.required], 4),
        Form.Field('text', 'cliente_rl_materno', 'Apellido Materno', '', [Validators.required], 4),
        Form.Field('text', 'cliente_rl_nombre', 'Nombre', '', [Validators.required], 4),
        Form.Field('text', 'cliente_rl_rfc', 'RFC', '', [Validators.required], 6),
        Form.Field('text', 'cliente_rl_curp', 'CURP', '', [Validators.required], 6),
      ], ['Guardar']), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds(this.props.match.params.id)
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(repLegal)
